import React, { useEffect, useState } from 'react';
import { API_URLS } from '../apiUrl';
import axiosInstance from '../components/axiosInstance';

const PropertyTypeEdit = ({ isOpen, closeModal, typeName, typeId }: any) => {
    const [formData, setFormData] = useState({
        type_primary_id: "",
        type_name: ""
    });

    const [errors, setErrors] = useState<any>({});
    const [successMessage, setSuccessMessage] = useState<string>("");
    const [dataExistMessage, setDataExistMessage] = useState<string>("");

    // Update form when modal opens
    useEffect(() => {
        if (isOpen) {
            setFormData({
                type_primary_id: typeId || "",
                type_name: typeName || "",
            });
            setErrors({});
        }
    }, [typeName, typeId, isOpen]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
        // Clear error when user starts typing
        if (errors.property_type_name) {
            setErrors({});
        }
    };

    const validateForm = (): boolean => {
        const newErrors: any = {};
        const trimmedName = formData.type_name?.trim();
    
        if (!trimmedName) {
            newErrors.property_type_name = "Property Type name is required";
        } else if (!/^[A-Za-z\s]+$/.test(trimmedName)) {
            newErrors.property_type_name = "Property Type name can only contain letters and spaces";
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
            const response = await axiosInstance.put(`${API_URLS.PropertyTypeUpdate}`, {
                type_name: formData.type_name.trim(),
                type_primary_id: typeId,
            });
            
            if (response.data.message) {
                setSuccessMessage(response.data.message);
                setTimeout(() => {
                    setSuccessMessage("");
                    closeModal();
                }, 5000);
            }
            
            setErrors({});
        } catch (error: any) {
            const errorMsg = error?.response?.data?.message || "Type name already exists. Please choose a different name.";
            setDataExistMessage(errorMsg);
            setTimeout(() => {
                setDataExistMessage("");
                closeModal();
            }, 5000);
        }
    };

    if (!isOpen) return null;

    const handleOutsideClick = (e: any) => {
        if (e.target === e.currentTarget) {
            closeModal();
        }
    };

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center" onClick={handleOutsideClick}>
            <div className="bg-white p-6 rounded-lg shadow-lg w-[500px] relative" onClick={(e) => e.stopPropagation()}>
                <h2 className="text-xl font-semibold mb-4">Edit Property Type</h2>

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label
                            htmlFor="property_type_name"
                            className="block mb-2 text-sm font-medium text-gray-900"
                        >
                            Property Type <span className="text-red-600">*</span>
                        </label>
                        <input
                            type="text"
                            id="property_type_name"
                            name="type_name"
                            value={formData.type_name}
                            onChange={handleChange}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            placeholder="Enter property type name"
                            autoFocus
                        />
                        {errors.property_type_name && (
                            <p className="text-sm text-red-600 mt-1">{errors.property_type_name}</p>
                        )}
                    </div>

                    <div className="flex justify-end">
                        <button
                            type="submit"
                            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                        >
                            Update
                        </button>
                    </div>
                </form>

                {successMessage && (
                    <div className="mt-4 p-3 bg-green-600 text-white rounded-lg flex justify-between items-center">
                        <span>{successMessage}</span>
                        <button
                            type="button"
                            onClick={() => setSuccessMessage('')}
                            className="text-white font-bold text-lg leading-none"
                        >
                            ×
                        </button>
                    </div>
                )}

                {dataExistMessage && (
                    <div className="mt-4 p-3 bg-yellow-600 text-white rounded-lg flex justify-between items-center">
                        <span>{dataExistMessage}</span>
                        <button
                            type="button"
                            onClick={() => setDataExistMessage('')}
                            className="text-white font-bold text-lg leading-none"
                        >
                            ×
                        </button>
                    </div>
                )}

                <button
                    type="button"
                    onClick={closeModal}
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-xl"
                >
                    ×
                </button>
            </div>
        </div>
    );
};

export default PropertyTypeEdit;